export default {"src":"/_next/static/media/feature.d60b3b76.svg","height":90,"width":428};